import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useAttendance } from '../../../hooks/Features/useAttendance'
import { itemsPerPage } from '../../../shared/data'
import CustomHeading from '../../CustomHeading'
import CustomPagination from '../../CustomPagination'
import InProgress from '../../InProgress'
import Layout from '../../Layout'
import Loader from '../../Loader'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'

export default function LeadLikelyClosureReport() {
  return (
    <Layout heading="Lead Likely Closure Report" none>
      <InProgress />
      {/* <CustomTable padding className={styles.table}>
        <CustomTableHeading
          heading={[
            'LIKELY CLOSURE DATE',
            'GION',
            'STATE',
            'CITY',
            'PROMOTER NAME',
            'OUTLET',
            'LEAD DATE',
            'EXPECTED ORDER VALUE',
            'TSM',
          ]}
        />
        <CustomTableRow className={styles.subHead}>
          <TableCell colSpan={9}></TableCell>
        </CustomTableRow>
        <TableBody className={styles.tr}>
          <CustomTableRow>
            <TableCell className={styles.region}>22-03-2020</TableCell>
            <TableCell colSpan={8}></TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell className={styles.region}>22-03-2020</TableCell>
            <TableCell colSpan={8}></TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell className={styles.region}>22-03-2020</TableCell>
            <TableCell colSpan={8}></TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell className={styles.region}>22-03-2020</TableCell>
            <TableCell colSpan={8}></TableCell>
          </CustomTableRow>
        </TableBody>
      </CustomTable> */}
    </Layout>
  )
}
